export class UserMaster {
  public USERID!: number;
  public Email!: string;
  public Password!: string;
  public FIRST_NAME!: string;
  public LAST_NAME!: string;
  public Address1!: string;
  public Address2!: string;
  public CITY!: string;
  public DISTRICT!: string;
  public STATEID!: number;
  public COUNTRYID!: number;
  public Phone!: string;
  public DOB!: string;
  public Created_Date!: string;
  public Modified_Date!: string;
  public SuscribeEmail!: number;
  public SuscribeSms!: number;
  public ISACTIVE!: number;
  public CreatedBy!: number;
  public ModifiedBy!: number;
  public EMP_ID!: number;
  public RoleId!: number;
  public LOC_CODE!: number;
}
